import { Icon } from "@blueprintjs/core";
import * as React from "react";

import { BreedJudgeHierarchyDto } from "../../../../../api";

export interface IJudgeIconProps {
  judges?: BreedJudgeHierarchyDto[];
  label?: string;
}

export const JudgeIcon: React.FunctionComponent<IJudgeIconProps> = ({ judges, label }) => {
  const jdgIcon = React.useCallback(() => {
    if (judges.length > 0) {
      // eslint-disable-next-line react/style-prop-object
      return (
        <div>
          <Icon icon="endorsed" intent="success" tagName="b" /> {label}
        </div>
      );
    } else {
      // eslint-disable-next-line react/style-prop-object
      return (
        <div>
          <Icon icon="circle" intent="warning" tagName="b" /> {label}
        </div>
      );
    }
  }, [judges.length, label]);
  return jdgIcon();
};
